var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("account-plan-message-modal", {
    ref: "modal",
    attrs: { id: "welcome-plan-information-modal" },
    on: {
      hide: function ($event) {
        _vm.computedShown = false
      },
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.$t("account.accountPlan.planModals.welcomePlanInfo.title")
                ) +
                "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("p", { staticClass: "text-gray" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t(
                      "account.accountPlan.planModals.welcomePlanInfo.bodyText"
                    )
                  ) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "text-gray" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t(
                      "account.accountPlan.planModals.welcomePlanInfo.bodyText2"
                    )
                  ) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c("account-plan-perks", { attrs: { plan: _vm.freeAccountPlan } }),
            _vm._v(" "),
            _c("p", { staticClass: "text-gray mt-2" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t(
                      "account.accountPlan.planModals.welcomePlanInfo.bodyTextEnd"
                    )
                  ) +
                  "\n    "
              ),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c("simple-button", { on: { click: _vm.handleGoToAccountPlan } }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("account.accountPlan.gotToAccountPlanPage")) +
                  "\n    "
              ),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }